const CONSOLIDATED = ['/aiTrain/auth', '/aiTrain/permission', '/aiTrain/scoreTemplate', '/aiTrain/knowledge']

export function isConsolidatedAiTrainPath(path) {
  return CONSOLIDATED.includes((path || '').replace(/\/$/, ''))
}

// 保留原服务端菜单与操作权限数据，只收起重复入口；历史地址交给场景页处理。
export function consolidateAiTrainMenus(menus) {
  return menus.map(menu => ({
    ...menu,
    hidden: isConsolidatedAiTrainPath(menu.resCode || menu.path) ? true : menu.hidden,
    ...(Array.isArray(menu.children) ? { children: consolidateAiTrainMenus(menu.children) } : {})
  }))
}

export function aiTrainLegacyDestination(to) {
  const path = (to.path || '').replace(/\/$/, '')
  const q = to.query || {}
  const isAuth = ['/aiTrain/auth', '/aiTrain/permission'].includes(path)
  const id = path === '/aiTrain/scoreTemplate' ? q.sceneId : isAuth && q.targetType !== 'category' ? q.targetId : null
  const query = {}
  if (Number.isSafeInteger(Number(id)) && Number(id) > 0) {
    query.configure = path === '/aiTrain/scoreTemplate' ? 'score' : 'auth'
    query.sceneId = String(id)
  }
  if (isAuth && q.targetType === 'category') query.configurationNotice = 'category'
  return { path: '/aiTrain/scene', query, replace: true }
}
